import { SUPPORTED_WEB_VIDEO_FORMATS } from '../../constants';

/**
 * @param {string} fileExt
 * @return {boolean}
 */
export function isWebVideoByFileExt(fileExt) {
  return fileExt ? SUPPORTED_WEB_VIDEO_FORMATS.includes(fileExt.toLowerCase()) : false;
}
